import { useQuery } from "@tanstack/react-query";
import { fetchBlogComments, fetchBlogDetail } from "../services/blogService";

function normalizeDetail(data = {}) {
  return {
    id: Number(data?.blog_id || 0),
    title: data?.title || "",
    description: data?.description || data?.short_description || "",
    stateName: data?.state_name || "",
    categoryName: data?.category_name || "News & Articles",
    categories: Array.isArray(data?.categories) ? data.categories : [],
    tags: Array.isArray(data?.tags) ? data.tags : [],
    totalLikes: Number(data?.total_likes || 0),
    totalViews: Number(data?.total_views || 0),
    totalComments: data?.total_comments || 0,
    isLiked: Number(data?.like_status || 0) === 1,
    isBookmarked: Number(data?.bookmark_status || 0) === 1,
    isRead: Number(data?.is_read || 0) === 1,
    timerSeconds: Number(data?.timer_seconds || 0),
  };
}

export function useBlogDetail(params = {}) {
  return useQuery({
    queryKey: ["dashboardBlogDetail", params],
    queryFn: async () => normalizeDetail(await fetchBlogDetail(params)),
    enabled: Number(params?.blog_id || 0) > 0,
    staleTime: 60 * 1000,
    retry: 2,
  });
}

export function useBlogComments(params = {}, options = {}) {
  const requestParams = typeof params === "object" ? params : { blog_id: Number(params) };

  return useQuery({
    queryKey: ["dashboardBlogComments", requestParams],
    queryFn: async () => {
      const data = await fetchBlogComments({ is_mobile: 1, ...requestParams });
      const pagination = data?.pagination || {};
      return {
        comments: Array.isArray(data?.comments) ? data.comments : [],
        pagination: {
          currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
          totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
          totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
        },
      };
    },
    enabled: (options.enabled ?? true) && Number(requestParams?.blog_id) > 0,
    staleTime: 30 * 1000,
  });
}
